module.exports = __webpack_public_path__ + "static/media/7.12105dc5.png";